/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedTasksRouteImport } from './routes/_authed/tasks'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedChatRouteImport } from './routes/_authed/chat'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedChatIndexRouteImport } from './routes/_authed/chat/index'
import { Route as AuthedChatThreadIdRouteImport } from './routes/_authed/chat/$threadId'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'
import { Route as AuthedAdminFeedbackRouteImport } from './routes/_authed/admin/feedback'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTasksRoute = AuthedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChatRoute = AuthedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChatIndexRoute = AuthedChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedChatRoute,
} as any)
const AuthedChatThreadIdRoute = AuthedChatThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => AuthedChatRoute,
} as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminFeedbackRoute = AuthedAdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AuthedAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/chat': typeof AuthedChatRouteWithChildren
  '/settings': typeof AuthedSettingsRoute
  '/tasks': typeof AuthedTasksRoute
  '/admin/feedback': typeof AuthedAdminFeedbackRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/chat/$threadId': typeof AuthedChatThreadIdRoute
  '/chat/': typeof AuthedChatIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/settings': typeof AuthedSettingsRoute
  '/tasks': typeof AuthedTasksRoute
  '/admin/feedback': typeof AuthedAdminFeedbackRoute
  '/admin/users': typeof AuthedAdminUsersRoute
  '/chat/$threadId': typeof AuthedChatThreadIdRoute
  '/chat': typeof AuthedChatIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/chat': typeof AuthedChatRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/tasks': typeof AuthedTasksRoute
  '/_authed/admin/feedback': typeof AuthedAdminFeedbackRoute
  '/_authed/admin/users': typeof AuthedAdminUsersRoute
  '/_authed/chat/$threadId': typeof AuthedChatThreadIdRoute
  '/_authed/chat/': typeof AuthedChatIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/signup'
    | '/admin'
    | '/chat'
    | '/settings'
    | '/tasks'
    | '/admin/feedback'
    | '/admin/users'
    | '/chat/$threadId'
    | '/chat/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/signup'
    | '/admin'
    | '/settings'
    | '/tasks'
    | '/admin/feedback'
    | '/admin/users'
    | '/chat/$threadId'
    | '/chat'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/signin'
    | '/signup'
    | '/_authed/admin'
    | '/_authed/chat'
    | '/_authed/settings'
    | '/_authed/tasks'
    | '/_authed/admin/feedback'
    | '/_authed/admin/users'
    | '/_authed/chat/$threadId'
    | '/_authed/chat/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/tasks': {
      id: '/_authed/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthedTasksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/chat': {
      id: '/_authed/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthedChatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/chat/': {
      id: '/_authed/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof AuthedChatIndexRouteImport
      parentRoute: typeof AuthedChatRoute
    }
    '/_authed/chat/$threadId': {
      id: '/_authed/chat/$threadId'
      path: '/$threadId'
      fullPath: '/chat/$threadId'
      preLoaderRoute: typeof AuthedChatThreadIdRouteImport
      parentRoute: typeof AuthedChatRoute
    }
    '/_authed/admin/users': {
      id: '/_authed/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/feedback': {
      id: '/_authed/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AuthedAdminFeedbackRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminFeedbackRoute: typeof AuthedAdminFeedbackRoute
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminFeedbackRoute: AuthedAdminFeedbackRoute,
  AuthedAdminUsersRoute: AuthedAdminUsersRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedChatRouteChildren {
  AuthedChatThreadIdRoute: typeof AuthedChatThreadIdRoute
  AuthedChatIndexRoute: typeof AuthedChatIndexRoute
}

const AuthedChatRouteChildren: AuthedChatRouteChildren = {
  AuthedChatThreadIdRoute: AuthedChatThreadIdRoute,
  AuthedChatIndexRoute: AuthedChatIndexRoute,
}

const AuthedChatRouteWithChildren = AuthedChatRoute._addFileChildren(
  AuthedChatRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedChatRoute: typeof AuthedChatRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTasksRoute: typeof AuthedTasksRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedChatRoute: AuthedChatRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTasksRoute: AuthedTasksRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
